import PropTypes from '../_util/vue-types';
import Checkbox from '../checkbox/Checkbox';
const OptMultiple = props => {
    const { class: className, checked } = props;
    return (<Checkbox class={className} style={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
        }} checked={checked}/>);
};
OptMultiple.inheritAttrs = false;
OptMultiple.displayName = 'OptMultiple';
OptMultiple.props = {
    class: String,
    customizeIconProps: PropTypes.any,
    checked: { type: Boolean, default: false },
};
export default OptMultiple;
